module.exports = __webpack_public_path__ + "static/media/python.3cf229ee.png";